// extracted by css-extract-rspack-plugin
export default {"cls1":"ActionNav-cls1_-VD","cls2":"ActionNav-cls2_3X7 ActionNav-cls1_-VD"};